import { render, staticRenderFns } from "./liveRanking.vue?vue&type=template&id=205351fd&scoped=true"
import script from "./liveRanking.vue?vue&type=script&lang=js"
export * from "./liveRanking.vue?vue&type=script&lang=js"
import style0 from "./liveRanking.vue?vue&type=style&index=0&id=205351fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205351fd",
  null
  
)

export default component.exports